import React, { useState } from "react";
import CustomInput from "../inputFields/Inputfields";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import axios from "axios";
import { endpoint } from "../../endpoint/endpoints";
import { ApplicationContext } from "../../context/ApplicationContext";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { ValidateEmail } from "../inputValidators/inputValidators";
import CustomButtonSolid from "../layout/buttons/solidButton";

// styling
const useStyles = makeStyles((theme) =>
  createStyles({
    forgotpassword: {
      textAlign: "center",
      justifyContent: "center",
    },

    typography: {
      paddingTop: "3%",
      paddingBottom: "2%",
    },

    nextbuttonforgotpassword: {
      paddingTop: "3%",
      marginLeft: "auto",
      paddingBottom: "5%",
    },
  })
);

// const apiResponse = {
//   status: 200,
//   data: {
//     error: !true,
//     // errorCode:0,
//     message: "success",
//   },
// };

function ForgotPassword() {
  // material ui
  const classes = useStyles();

  //page title seen on browser
  React.useEffect(() => {
    document.title = "Forgot password";
  }, []);

  const { popAuthState, setLoading, setMessage, openSnackbar, setSeverity } =
    React.useContext(ApplicationContext);

  /* state */
  const [username, setUsername] = useState({
    value: "",
    error: false,
    errorMessage: "",
  });

  /* functions */
  const onChange = (event) => {
    let error = { error: "", errorMessage: "" };
    switch (event.target.name) {
      case "username":
        // setUsername(event.target.value);
        error = ValidateEmail(event.target.value);
        setUsername((prevState) => {
          return {
            value: event.target.value,
            error: error.error,
            errorMessage: error.errorMessage,
          };
        });
        break;

      default:
        break;
    }
  };

  // navigate
  const navigate = useNavigate();

  /* BACK END CODE  */
  const onSubmit = async (event) => {
    setLoading(true);

    event.preventDefault();
    try {
      const response = await axios.post(
        endpoint.FORGOT_PASSWORD_ENDPOINT, //endpoint
        { email: username.value } //body
        // {
        //   headers: {
        //     "user-token": localStorage.getItem("user_token"),
        //     authorization: localStorage.getItem("authorization"),
        //   },
        // }
      );

      if (response.status === 200) {
        if (response.data.error === false) {
          popAuthState({
            email: username.value,
          });
          navigate("/changePassword");
          setLoading(false);
        } else {
          switch (response.data.errorCode) {
            //missing input fields
            case 0:
              setMessage("Missing input fields");
              setSeverity("error");
              openSnackbar();
              setLoading(false);
              break;
            //Unable to query users table
            case 1:
              setMessage("An error occurred. Please try again later");
              setSeverity("error");
              openSnackbar();
              setLoading(false);
              break;
            //
            case 2:
              setMessage("Invalid email");
              setSeverity("error");
              openSnackbar();
              setLoading(false);
              break;
            //Unable to write user registration challenge
            case 3:
              setMessage("An error occurred. Please try again later");
              setSeverity("error");
              openSnackbar();
              setLoading(false);
              break;
            //Unable to send confirmation email
            case 4:
              setMessage("Unable to send confirmation email");
              setSeverity("error");
              openSnackbar();
              setLoading(false);
              break;
            default:
              setMessage("Unable to send confirmation email");
              setSeverity("error");
              openSnackbar();
              setLoading(false);
              break;
          }
        }
      } else {
        setMessage("Unexpected error occured");
        setSeverity("error");
        openSnackbar();
        setLoading(false);
      }
    } catch (error) {
      setMessage("Unexpected error occured");
      setSeverity("error");
      openSnackbar();
      setLoading(false);
    }
  };

  return (
    <Box className={classes.forgotpassword}>
      <Box>
        <Typography className={classes.typography}>
          Please enter the email address you used to create your account:
        </Typography>
      </Box>
      <Box className={classes.forgotpasswordinput}>
        <form onSubmit={onSubmit}>
          <CustomInput
            focused={true}
            value={username.value}
            onChange={onChange}
            label=""
            required
            name="username"
            type="email"
            inputProps={{
              autoComplete: "email",
            }}
            error={username.error}
            errorMessage={username.errorMessage}
          />
          <Box className={classes.nextbuttonforgotpassword}>
            <CustomButtonSolid
              type="submit"
              text="NEXT"
              disabled={username.error || !username.value}
            />
          </Box>
        </form>
      </Box>
    </Box>
  );
}

export default ForgotPassword;
